import { EMPTY_COSMETICS, type UnlockKind } from '@anidex/shared/economy';
import { Avatar } from '../Avatar';
import { BadgeEmblem, BannerFx, FrameBorder, TitlePlate } from './Cosmetics';

export function CosmeticPreview({
  kind,
  itemKey,
  label,
  portrait = null,
  compact = false,
}: {
  kind: UnlockKind;
  itemKey: string;
  label: string;
  portrait?: string | null;
  compact?: boolean;
}) {
  if (kind === 'title') return <TitlePlate titleKey={itemKey} label={label} size={compact ? 'inline' : 'showcase'} />;
  if (kind === 'badge') return <BadgeEmblem badgeKey={itemKey} size={compact ? 26 : 64} />;
  if (kind === 'banner') {
    return (
      <span className={`cosmetic-banner${compact ? ' cosmetic-banner--compact' : ''}`}>
        <BannerFx fxKey={itemKey} />
      </span>
    );
  }
  const user = {
    username: label,
    avatar: portrait ? { characterId: 0, imageUrl: portrait } : null,
    cosmetics: {
      ...EMPTY_COSMETICS,
      frame: kind === 'frame' ? itemKey : null,
      avatar: kind === 'avatar' ? itemKey : null,
    },
  };
  if (kind === 'frame' && !compact) {
    return (
      <span className="cosmetic-frame-pair">
        <Avatar user={user} size={72} />
        <span className="cosmetic-banner cosmetic-banner--compact">
          <FrameBorder frameKey={itemKey} />
        </span>
      </span>
    );
  }
  return <Avatar user={user} size={compact ? 30 : 72} />;
}
